// import React, { useEffect } from "react";
// import { Card } from "antd";
// import { Radio } from "antd";
// import { Badge } from "antd";
// import { CheckOutlined } from "@ant-design/icons";
// import { Crown, Zap, Building } from "lucide-react";
// import "./SubscriptionPlanTab.css";

// const subscriptionPlans = {
//     basic: {
//         name: "Basic",
//         icon: Zap,
//         price: "$9/month",
//         features: [
//             "Up to 3 brands",
//             "Basic content management",
//             "Standard support",
//             "Basic analytics"
//         ],
//         permissions: ["view_content", "edit_content"]
//     },
//     pro: {
//         name: "Pro",
//         icon: Crown,
//         price: "$29/month",
//         features: [
//             "Up to 10 brands",
//             "Advanced content management",
//             "Priority support",
//             "Advanced analytics",
//             "User management",
//             "API access"
//         ],
//         permissions: [
//             "view_content",
//             "edit_content",
//             "manage_users",
//             "api_access",
//             "advanced_analytics"
//         ]
//     },
//     business: {
//         name: "Business",
//         icon: Building,
//         price: "$99/month",
//         features: [
//             "Unlimited brands",
//             "Enterprise content management",
//             "24/7 dedicated support",
//             "Full analytics suite",
//             "Advanced user management",
//             "Full API access",
//             "Custom integrations",
//             "White-label options"
//         ],
//         permissions: [
//             "view_content",
//             "edit_content",
//             "manage_users",
//             "api_access",
//             "advanced_analytics",
//             "custom_integrations",
//             "white_label"
//         ]
//     }
// };

// const SubscriptionPlanTab = ({ userData, setUserData, viewOnly = false, subscriptionPlans=[] }) => {

//     useEffect(() => {
//         console.log("SubscriptionPlanTab mounted with subscriptionPlans:", JSON.stringify(subscriptionPlans));
//     }, [subscriptionPlans]);

//     const handlePlanChange = (e) => {
//         setUserData({ ...userData, subscriptionPlan: e.target.value || null });
//     };

//     const selectedPlan = userData ? subscriptionPlans[userData.subscriptionPlan] || null : null;

//     return (
//         <div className="subscription-grid">
//             {/* Plan Selection */}
//             <div className="subscription-left">
//                 <Card title="Current Subscription Plan">
//                     {viewOnly ? (
//                         selectedPlan ? (
//                             <div className="plan-selected-view">
//                                 <div className="plan-icon">
//                                     <selectedPlan.icon />
//                                 </div>
//                                 <div>
//                                     <h3>{selectedPlan.name}</h3>
//                                     <p>{selectedPlan.price}</p>
//                                 </div>
//                             </div>
//                         ) : (
//                             <p className="muted-text">No subscription plan selected</p>
//                         )
//                     ) : (
//                         <Radio.Group
//                             value={selectedPlan ? userData.subscriptionPlan : null}
//                             onChange={handlePlanChange}
//                             className="plan-options"
//                         >
//                             {Object.entries(subscriptionPlans).map(([key, plan]) => {
//                                 const Icon = plan.icon;
//                                 const isSelected = selectedPlan ? userData.subscriptionPlan === key : false;

//                                 return (
//                                     <div
//                                         key={key}
//                                         className={`plan-option ${isSelected ? "selected" : ""}`}
//                                     >
//                                         <Radio value={key} className="plan-radio">
//                                             <div className="plan-radio">
//                                                 <div className="plan-details">
//                                                     <div className={`plan-icon ${isSelected ? "active" : ""}`}>
//                                                         <Icon size={20} />
//                                                     </div>
//                                                     <div>
//                                                         <div className="plan-title">
//                                                             <h3>{plan.name}</h3>
//                                                             {key === "pro" && <Badge>Popular</Badge>}
//                                                             {key === "business" && <Badge>Enterprise</Badge>}
//                                                         </div>
//                                                         <div className="plan-price">{plan.price}</div>
//                                                     </div>
//                                                 </div>
//                                                 {isSelected && (
//                                                     <div className="checkmark">
//                                                         <CheckOutlined />
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </Radio>
//                                     </div>
//                                 );
//                             })}
//                         </Radio.Group>
//                     )}
//                 </Card>
//             </div>

//             {/* Feature Highlights */}
//             <div className="subscription-right">
//                 <Card
//                     title={
//                         selectedPlan ? `${selectedPlan.name} Features` : "Features Overview"
//                     }
//                 >
//                     {selectedPlan ? (
//                         <>
//                             <div className="feature-list">
//                                 {selectedPlan.features.map((feature, idx) => (
//                                     <div key={idx} className="feature-item">
//                                         <CheckOutlined className="check-icon" />
//                                         <span>{feature}</span>
//                                     </div>
//                                 ))}
//                             </div>

//                             <div className="permissions">
//                                 <h4>Available Permissions</h4>
//                                 <div className="permissions-list">
//                                     {selectedPlan.permissions.map((perm) => (
//                                         <Badge key={perm} className="permission-badge">
//                                             {perm.replace("_", " ")}
//                                         </Badge>
//                                     ))}
//                                 </div>
//                             </div>
//                         </>
//                     ) : (
//                         <p className="muted-text">Select a plan to see features</p>
//                     )}
//                 </Card>
//             </div>
//         </div>
//     );
// };

// export default SubscriptionPlanTab;

import React, { useEffect } from "react";
import { Card, Radio, Badge, Tag } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { Crown, Zap, Building, Check, X } from "lucide-react";
import "./SubscriptionPlanTab.css";
import { QUOTA_FIELDS, FEATURE_FIELDS, OPERATIONAL_FIELDS } from "../../../data/planSchema";

// You can define a simple icon map for known plan names
const planIcons = {
  Free: Zap,
  Basic: Zap,
  Pro: Crown,
  Premium: Building,
  Business: Building,
};

/**
 * Resolve a plan field value — checks both the canonical key and the apiAlias.
 */
const getPlanFieldValue = (plan, field) => {
  if (!plan) return field.defaultValue;
  if (field.key in plan) return plan[field.key];
  if (field.apiAlias && field.apiAlias in plan) return plan[field.apiAlias];
  return field.defaultValue;
};

/**
 * Format a quota value for display.
 */
const formatQuotaValue = (field, value) => {
  if (value === 0 || value === null || value === undefined) return "Unlimited";
  if (field.key === "max_storage_mb" && typeof value === "string") return value; // already formatted
  if (field.key === "max_storage_mb" && typeof value === "number") {
    if (value >= 1024) return `${(value / 1024).toFixed(1)} GB`;
    return `${value} MB`;
  }
  return String(value);
};

const SubscriptionPlanTab = ({
  userData,
  viewOnly = false,
  subscriptionPlans = [],
  onDataChange = () => {},
}) => {

    const [selectedPlanId, setSelectedPlanId] = React.useState();

  useEffect(() => {
    console.log(
      "SubscriptionPlanTab mounted with subscriptionPlans:",
      JSON.stringify(subscriptionPlans, null, 2)
    );
  }, [subscriptionPlans]);

  useEffect(() => {
    if(userData && userData.plan && userData.plan.planid) {
        setSelectedPlanId(userData.plan.planid);
    } else {
        setSelectedPlanId(null);
    }
  }, [userData]);

  useEffect(() => {
    console.log("Selected plan ID:", selectedPlanId);
    onDataChange(selectedPlanId || undefined);
  }, [selectedPlanId]);

  const handlePlanChange = (e) => {
    console.log("Plan changed to: " + e.target.value);
    setSelectedPlanId(e.target.value);
  };

  const selectedPlan = subscriptionPlans.find(
    (p) => String(p.planid) === selectedPlanId
  );

  return (
    <div className="subscription-grid">
      {/* Plan Selection */}
      <div className="subscription-left">
        <Card title="Current Subscription Plan">
          {viewOnly ? (
            selectedPlan ? (
              <div className="plan-selected-view">
                <div className="plan-icon">
                  {(() => {
                    const Icon = planIcons[selectedPlan.planname] || Zap;
                    return <Icon />;
                  })()}
                </div>
                <div>
                  <h3>{selectedPlan.planname}</h3>
                  <p>
                    {selectedPlan.storage_limit} storage •{" "}
                    {selectedPlan.brands_limit || "Unlimited"} brands •{" "}
                    {selectedPlan.screens_limit || "Unlimited"} screens
                  </p>
                </div>
              </div>
            ) : (
              <p className="muted-text">No subscription plan selected</p>
            )
          ) : (
            <Radio.Group
              value={selectedPlanId || undefined}
              onChange={handlePlanChange}
              className="plan-options"
            >
              {subscriptionPlans.map((plan) => {
                const Icon = planIcons[plan.planname] || Zap;
                const isSelected =
                  selectedPlan && selectedPlan.planid === plan.planid;

                return (
                  <div
                    key={plan.planid}
                    className={`plan-option ${isSelected ? "selected" : ""}`}
                  >
                    <Radio value={plan.planid} className="plan-radio">
                      <div className="plan-radio">
                        <div className="plan-details">
                          <div
                            className={`plan-icon ${isSelected ? "active" : ""}`}
                          >
                            <Icon size={20} />
                          </div>
                          <div>
                            <div className="plan-title">
                              <h3>{plan.planname}</h3>
                              {plan.planname === "Pro" && <Badge>Popular</Badge>}
                              {plan.planname === "Premium" && (
                                <Badge>Enterprise</Badge>
                              )}
                            </div>
                            <div className="plan-price">
                              {plan.storage_limit} storage
                            </div>
                          </div>
                        </div>
                        {isSelected && (
                          <div className="checkmark">
                            <CheckOutlined />
                          </div>
                        )}
                      </div>
                    </Radio>
                  </div>
                );
              })}
            </Radio.Group>
          )}
        </Card>
      </div>

      {/* Plan Highlights */}
      <div className="subscription-right">
        <Card
          title={
            selectedPlan
              ? `${selectedPlan.planname} Highlights`
              : "Plan Overview"
          }
        >
          {selectedPlan ? (
            <div className="plan-highlights" style={{ display: "flex", flexDirection: "column", gap: 20 }}>

              {/* Resource Quotas */}
              <div>
                <h4 style={{ fontSize: 13, fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 10 }}>
                  Resource Quotas
                </h4>
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  {QUOTA_FIELDS.map((field) => {
                    const value = getPlanFieldValue(selectedPlan, field);
                    return (
                      <div key={field.key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: "1px solid #f1f5f9" }}>
                        <span style={{ fontSize: 13, color: "#475569" }}>{field.label}</span>
                        <Tag color={value === 0 ? "green" : "blue"} style={{ margin: 0 }}>
                          {formatQuotaValue(field, value)}
                        </Tag>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Feature Access */}
              <div>
                <h4 style={{ fontSize: 13, fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 10 }}>
                  Feature Access
                </h4>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {FEATURE_FIELDS.map((field) => {
                    const enabled = !!getPlanFieldValue(selectedPlan, field);
                    return (
                      <Tag
                        key={field.key}
                        color={enabled ? "green" : "default"}
                        icon={enabled ? <Check size={12} style={{ marginRight: 4 }} /> : <X size={12} style={{ marginRight: 4 }} />}
                        style={{ display: "inline-flex", alignItems: "center", fontSize: 12 }}
                      >
                        {field.label}
                      </Tag>
                    );
                  })}
                </div>
              </div>

              {/* Operational Limits */}
              <div>
                <h4 style={{ fontSize: 13, fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 10 }}>
                  Operational
                </h4>
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  {OPERATIONAL_FIELDS.map((field) => {
                    const value = getPlanFieldValue(selectedPlan, field);
                    return (
                      <div key={field.key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: "1px solid #f1f5f9" }}>
                        <span style={{ fontSize: 13, color: "#475569" }}>{field.label}</span>
                        <span style={{ fontSize: 13, fontWeight: 500, color: "#0f172a" }}>
                          {field.key === "support_level" ? String(value).charAt(0).toUpperCase() + String(value).slice(1) : String(value)}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>

            </div>
          ) : (
            <p className="muted-text">Select a plan to see highlights</p>
          )}
        </Card>
      </div>
    </div>
  );
};

export default SubscriptionPlanTab;
